import { translateAction } from "@cdv/jazz-i18n";
import { useMatchParams } from "@cdv/jazz-ui";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ReactElement, useState } from "react";

type Props = React.PropsWithChildren;

export default function Content(props: Props): ReactElement {
  const { resource } = useMatchParams();
  const [active, setActive] = useState(false);

  if (!active) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", background: "#EEF6F8", minHeight: "98vh" }}>
        <Box sx={{ mx: "auto", position: "relative" }}>
          <Stack sx={{ alignItems: "center", justifyContent: "center", py: 2 }} spacing={3}>
            <img src="/assets/logo_stressoff.svg" alt="Logo" style={{ maxHeight: "124px" }} />
            <img src="/assets/02_ilustr_intro-a.svg" alt="Logo" style={{ maxHeight: "163px" }} />

            <Typography sx={{ textAlign: "center" }}>
              Přepni stres na off. <br /> Tahle jízda patří jen tobě.
            </Typography>

            <Stack sx={{ alignItems: "center", justifyContent: "center" }} spacing={3}>
              <Button
                variant="contained"
                size="large"
                sx={{ width: "211px" }}
                onClick={() => setActive(true)}
              >
                {translateAction(resource, "enter")}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Box>
    );
  } else {
    return <>{props.children}</>;
  }
}
